import React, {useState} from "react";
import { makeStyles } from '@material-ui/core/styles';
import $ from 'jquery';


import Button from '@material-ui/core/Button';
import HashTagTextInput from './HashTagTextInput';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'


const useStyles = makeStyles((theme) => ({
  addbtn:{
    textTransform: 'initial', 
    paddingTop: 2, 
    paddingBottom: 2, 
    minWidth: 0, 
    marginLeft: 5,
    '&.up':{
      color: 'rgb(3 112 237)',
      borderColor: 'rgb(3 112 237)'
    },
    '&.down':{
      color: 'rgb(220, 50, 32)',
      borderColor: 'rgb(220, 50, 32)'
    }
  },
  hashbtn:{
    fontSize: '0.8125rem',
    textTransform: 'initial',
    paddingLeft: '5px', 
    minWidth: 0, 
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500, 
    borderRadius: 4,
    marginLeft: 5,
    letterSpacing: '0.02857em',
    maxHeight: 26,
    display: 'inline-block',
    border: 'solid 1px',
    lineHeight: 1.75,
    paddingTop: 2, 
    paddingBottom: 2, 
    verticalAlign: 'middle',
    '&.up':{
      color: 'rgb(3 112 237)',
      borderColor: 'rgb(3 112 237)'
    },
    '&.down':{
      color: 'rgb(220, 50, 32)',
      borderColor: 'rgb(220, 50, 32)'
    },
  },
  actionbtn:{
    height: '100%', 
    padding: 0,
    width: 24, 
    backgroundColor: 'white',
    '&.add':{
      border: 0,
      borderRight: '1px solid',
      borderLeft: '1px solid',
      borderRadius: 0
    },
    '&.close':{
      border: 0,
      borderRadius: 4
    },
    '&.up':{
      color: 'rgb(3 112 237)',
      borderColor: 'rgb(3 112 237)'
    },
    '&.down':{
      color: 'rgb(220, 50, 32)',
      borderColor: 'rgb(220, 50, 32)'
    },
    '&:disabled':{
      color: 'grey'
    }
    },
    textfield:{
      padding:0,
      width: 72,
      verticalAlign: 'middle',
      marginRight: 5,
    }
}));

export default function HashTagInput(props){
  const classes=useStyles();

  const [adding, setAdding]=useState(false);
  const [hashtaginput, setHashtagInput]=useState('');
  const [validity, setValidity]=useState(false);

  const handleChange = (event, value) => {
    event.preventDefault();
    var textval=value
    setHashtagInput(textval);
    setValidity((textval.length>1));
  }

  const handleSelect = (event, value) =>{
    var textval=value
    if(textval!=null){
      setHashtagInput(textval);
      setValidity((textval.length>1));
    }
}

const handleClose =()=>{
    $('#hashtag-input-'+props.direction+'-'+props.comment).val('');
      setAdding(false);
      setHashtagInput('');
      setValidity(false);
  }

  const checkAdd = ()=>{
    // validate the input 
    if(hashtaginput.indexOf(' ')>=0){
      window.alert("Your hashtag contains white space. Please remove the white space.");
    }else{
      if(hashtaginput.length>21){
        window.alert("Your hashtag is too long and has more than 20 characters. Please revise the hashtag to a shorter one.");
      }else{
        handleAdd();
      }}
    }

    const handleAdd = () =>{
     props.addHashtag( props.username, props.commentID, props.direction, hashtaginput);
     handleClose();
    }

    const onAdd= () =>{
      setAdding(!adding);
    }

    return (
      (adding? 
        <div  className={classes.hashbtn + ' ' +props.direction} style={{marginBottom:'3px'}}>
          <span style={{width:'100px'}}>
            <HashTagTextInput direction={props.direction} onChangeFunc={handleChange} onSelectFunc={handleSelect} onEnterFunc={checkAdd} options={props.options}/>  
          </span>  
          <span>
            <button className={classes.actionbtn+' add ' + props.direction} disabled={!validity} onClick={checkAdd}>
              <FontAwesomeIcon icon={faPlus} size='xs'/>
              </button>
          </span>
          <span>
            <button className={classes.actionbtn+' close ' + props.direction} onClick={handleClose}>
              <FontAwesomeIcon icon={faTimes} size='xs'/> 
            </button>
          </span>
      </div>
        : 
        <Button variant="outlined" size='small' style={{marginBottom:'3px'}} className={classes.addbtn + ' ' +props.direction}
        onClick={onAdd}>+</Button>
        )
    )
}